/**
 * BookingPlatformSettingsService — read/write the singleton row of feature +
 * channel kill switches that gates the new BookingManagement subsystems.
 *
 * Route: api/booking-platform-settings  (singleton — no id in the URL)
 */
import { BaseService } from '../base';
export class BookingPlatformSettingsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookingPlatformSettingsService.DEFAULT_SERVICE_PATH,
            basePath: 'api/booking-platform-settings',
            endpoints: config?.endpoints,
        });
    }
    async get() {
        const r = await this.http.get(this.buildUrl());
        return r.data ?? null;
    }
    async update(settings) {
        const r = await this.http.put(this.buildUrl(), settings);
        return r.data ?? null;
    }
}
BookingPlatformSettingsService.DEFAULT_SERVICE_PATH = 'booking-management';
//# sourceMappingURL=BookingPlatformSettingsService.js.map